<template>
    <div id="index" ref="appRef" style="color: white !important;" @click="screen">
      <div v-for="item of 500" :key="item" class="snowflake"></div>
      <div class="bg">
          <dv-loading v-if="loading">Loading...</dv-loading>
          <div v-else class="host-body">
            <div class="d-flex jc-center">
              <div class="left-head">
                <div class="left-weather">
                  <svg t="1716190336910" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1508" width="16" height="16"><path d="M672 320C672 408.128 600.128 480 512 480 423.872 480 352 408.128 352 320 352 231.872 423.872 160 512 160 600.128 160 672 231.872 672 320M512 0C335.136 0 192 143.136 192 320 192 358.112 196.384 397.504 212.64 431.872L440.736 915.616C453.248 943.136 482.016 960 512 960 542.016 960 570.752 943.136 583.872 915.616L811.36 431.872C827.616 397.504 832 358.112 832 320 832 143.136 688.864 0 512 0" fill="#ffffff" p-id="1509"></path></svg>
                  <span>{{weather.city}}&nbsp;</span>
                  <img :src='weatherImg' width="35px" height="auto" />
                  <span>{{weather.weather}}&nbsp;</span>
                  <svg t="1716190393250" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1991" width="16" height="16"><path d="M461.36845043 17.17233859a150.37773614 150.37773614 0 0 1 150.00775793 149.93376212v397.33834286a243.39031562 243.39031562 0 0 1 97.47081961 194.99713605c0 134.93113643-112.3809505 247.42308066-247.42308067 247.42307969s-247.47857755-112.51044321-247.47857656-247.42307969c0-82.48669287 37.55281162-150.00775793 97.48931855-194.97863709V167.1061007a150.37773614 150.37773614 0 0 1 149.93376115-149.93376211z m3.81077851 52.44444355c-52.48144145 0-97.48931856 45.02637602-97.48931855 97.48931857v423.6253105c-59.99200383 33.7420331-97.48931856 97.45232063-97.48931855 168.71016841 0 108.6996647 90.01575412 198.6784209 198.71541882 198.67842092s198.641423-90.01575412 198.64142398-198.67842092c0-68.63100062-38.21877215-130.23240986-91.23668342-164.84389301l-6.21563723-3.88477434c-0.2219875 0-0.42547506-0.3144813-0.6289636-0.92494598l-0.57346673-2.79333679-0.53646881-4.513737-0.9804428-13.7262005-0.64746258-14.02218287-0.96194384-29.37628778-1.57240851-83.74461908-0.92494595-98.39576554-0.57346673-154.15151574V167.1061007a96.80485809 96.80485809 0 0 0-97.45231967-97.48931856z m48.70766088 296.16773949V617.62884446a149.97076004 149.97076004 0 1 1-97.48931856 0V365.78452163zM735.07849873 65.87999946c41.23409645 3.69978477 74.95763159 37.47881579 74.95763159 74.97613055a74.97613054 74.97613054 0 1 1-74.95763159-74.95763156z m1e-8 52.48144149c-11.22884607 0-22.51318801 11.22884607-22.51318803 22.49468906s11.28434198 26.26846871 26.28696862 26.26846868a25.65800504 25.65800504 0 0 0 26.23147078-26.26846868c0-14.98412674-15.03962359-22.49468905-30.00525138-22.49468906z m0 0"  :fill='tempColor' p-id="1992"></path></svg>
                  <span :style="{color: tempColor}">{{weather.temp}}°C &nbsp;</span>
                  <svg t="1716190426103" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2240" width="16" height="16"><path d="M541.6 175.6L512 137l-29.6 38.6c-23.8 31.2-233 308-233 443.8C249.4 767 367.2 887 512 887s262.6-120 262.6-267.6c0-135.8-209.2-412.6-233-443.8zM512 734.2c-20.8 0-37.6-17.2-37.6-38.2 0-21.2 16.8-38.2 37.6-38.2 20 0 37.6-16.4 37.6-35.2 0-21.2 18.2-37 37.6-38 20.8 0 37.4 17.2 37.4 38.4-0.2 60.2-51.8 111.2-112.6 111.2z" :fill='sdColor' p-id="2241"></path></svg>
                  <span :style="{color: sdColor}">{{weather.SD}}</span>
                  <span>&nbsp; {{weather.WD}}{{weather.WS}} &nbsp;</span>
                  <svg t="1716190447944" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2489" width="16" height="16"><path d="M302.4 742.3c140.2 30.1 278.3-59.2 308.5-199.4 24-114.5 136.4-187.9 250.9-163.8 23 4.8 45 13.4 65.2 25.5-6.7-23.3-15.5-45.9-26.3-67.6-6.9-14.2-14.6-28-23.1-41.3C752.9 97.3 490.8 37.6 292.4 162.4c-89.1 56.1-154.3 143.3-182.7 244.7-2.3 8.5-5.1 17.1-6.9 25.8-18.4 86.2 8.2 175.9 70.5 238.2-16.6 32.4-30.7 66-42.4 100.5-8.4 25.5-15.4 51.3-21.2 77.5-5.1 25.4-10.4 54.6-12.7 77.7h104.7c-0.7-21.4-0.2-42.8 1.4-64.1 1.8-23.1 4.6-46.1 9-69.2 9.4-50.9 24.9-100.4 46.1-147.6 21.5-48 48.6-93.3 80.9-134.9 28.6-36.9 60.9-70.9 96.4-101.2 4.4-3.7 17.5-13.8 13.8-9.7C287 588.3 302.4 742.3 302.4 742.3z" :fill='pmColor' p-id="2490"></path></svg>
                  <span :style="{color: pmColor}">{{weather.aqi}}</span>
                </div>
                <dv-decoration-10 class="dv-dec-10" :color="decorationColor"/>
<!--                <div class="left-title" v-html="this.companyName">山东喜迎人家食品有限公司</div>-->
              </div>

              <div class="d-flex jc-center" style="height: 40px">
                <div class="title" style="height: 76px;">
                  <div class="title-text" style="font-weight: bold; position: absolute; bottom: 0; left: 50%; -webkit-transform: translateX(-50%); transform: translateX(-50%);
                      border-top: 94px solid #095dd4; border-left: 47px solid transparent; border-right: 47px solid transparent;width: 524px; height: 96px;">
                    <div class="title-text" style="font-weight: bold; position: absolute; bottom: 0; left: 50%; -webkit-transform: translateX(-50%); transform: translateX(-50%);
                      border-top: 94px solid #11386e; border-left: 47px solid transparent; border-right: 47px solid transparent;width: 520px; height: 100px;">
                      <div style="font-size: 36px;padding-top: -20px;margin-top: -52px;display: flow-root;">七个蛋白数据运营中心</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="right-head">
                <div class="rigth-time">
                  <span >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
                </div>
                <dv-decoration-10 class="dv-dec-10-s" :color="decorationColor"/>
<!--                <div class="right-title">七个蛋白&nbsp;公司出品</div>-->
              </div>
            </div>

            <div class="body-box">
              <div class="content-box">
                <div class="mg10" style="width: 100%">
                  <dv-border-box-8 :dur="9" :color="boardColor" title="公司数据" style="width: 420px;height: 450px;"  >
                    <div class="titleName">
                      <span class="name-box">公司数据</span>
                    </div>
                    <company-data/>
                  </dv-border-box-8>
                </div>

                <div class="mg10" style="width: 100%">
                  <dv-border-box-8 :dur="9" :color="boardColor" title="业务数据" style="width: 420px;height: 470px;" >
                    <div class="titleName">业务数据</div>
                    <div style="display: flex">
                      <company-sell/>
                    </div>
                  </dv-border-box-8>
                </div>
              </div>
              <div class="center-box">
                <div class="mg10" style="width: 100%;height: 650px;">
                  <dv-border-box-8 :dur="9" :color="boardColor" title="客户分布" style="height: 650px;">
                    <div class="titleName">客户分布</div>
                    <fly-map />
                  </dv-border-box-8>
                </div>
                <div class="mg10" style="width: 100%">
                  <dv-border-box-8 :dur="9" :color="boardColor" title="统计用数据" style="height: 250px;">
                    <div class="titleName">统计数据</div>
                    <div style="display: flex">
                      <company-core/>
                      <company-year-chart/>
                    </div>
                  </dv-border-box-8>
                </div>
              </div>
              <div class="bottom-box">
                <div class="mg10" style="height: 32%">
                  <dv-border-box-8 :dur="9" :color="boardColor" title="用户数据">
                    <div class="titleName">用户数据</div>
                    <company-human/>
                  </dv-border-box-8>
                </div>

                <div class="mg10" style="height: 67%">
                  <dv-border-box-8 :dur="9" :color="boardColor" title="IOT物联网">
                    <div class="titleName">IOT物联网</div>
                    <company-device/>
                  </dv-border-box-8>
                </div>
              </div>
            </div>
            <div class=""></div>
          </div>
        </div>
    </div>
</template>

<script>
import drawMixin from "../utils/drawMixin";
import { formatTime } from '../utils/index.js';
import axios from "axios";
import CompanyData from "@/views/companyData";
import CompanySell from "@/views/companySell";
import CompanyCore from "@/views/companyCore";
import CompanyYearChart from "@/views/companyYearChart";
import CompanyDevice from "@/views/companyDevice";
import flyMap from "@/views/flyMap";
import CompanyHuman from "@/views/companyHuman";

export default {
  mixins: [ drawMixin ],
  data() {
    return {
      //
      layout: '3X3', //默认布局
      activeComponents: [],
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      decorationColor: ['rgb(11, 94, 178)', 'rgb(34, 61, 90)'],
      weather: {},
      weatherImg: '', // 天气图片变量
      isDev : process.env.NODE_ENV === 'development' ? 'kbdev' : '',
      boardColor: ['rgb(34, 61, 90)', 'rgb(11, 94, 178)'],
      companyName: '',
      fullscreen: false,
      tempColor: '',
      sdColor: '',
      pmColor: '',
    }
  },
  components: {
    CompanyHuman,
    CompanyDevice,
    CompanyCore,
    CompanyData,
    flyMap,
    CompanySell,
    CompanyYearChart
  },
  mounted() {
    this.cancelLoading()
    this.weatherData('上海')
  },
  beforeDestroy () {
    clearInterval(this.timing)
  },
  methods: {
    screen() {
      let element = document.documentElement;
      if (!this.fullscreen) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },

    timeFn() {
      //
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    weatherData(city) {
      axios.get(`${this.isDev}/io/get_weather?city=` + city)
          .then(response => {
            this.weather = response.data.weather,
            console.log("天气", this.weather)
            // this.weather.weather = '暴雨'

            // 天气图标
            const weatherIcons = {
              '阴': require('../assets/阴.png'),
              '晴': require('../assets/晴.png'),
              '雾霾': require('../assets/雾霾.png'),
              '晴转多云': require('../assets/晴转多云.png'),
              '小雨': require('../assets/小雨.png'),
              '中雨': require('../assets/中雨.png'),
              '大雨': require('../assets/大雨.png'),
              '暴雨': require('../assets/暴雨.png'),
            };
            // 默认天气图标
            this.weatherImg = weatherIcons[this.weather.weather] || require('../assets/晴转多云.png');

            // 温度颜色
            const tempRanges = [
              { range: [-Infinity, 0], color: '#05f3f3' },
              { range: [0, 10], color: '#1ce5ec' },
              { range: [10, 20], color: '#a2fb92' },
              { range: [20, 30], color: '#fbea52' },
              { range: [30, 37], color: '#fca103' },
              { range: [37, Infinity], color: '#fc3d00' },
            ];
            this.tempColor = tempRanges.find(tempRange => this.weather.temp >= tempRange.range[0] && this.weather.temp < tempRange.range[1]).color

            // 湿度颜色
            const humidityRanges = [
              { range: [-Infinity, 20], color: '#1b47cb' },
              { range: [20, 40], color: '#0232c5' },
              { range: [40, 60], color: '#022db1' },
              { range: [60, 80], color: '#02289e' },
              { range: [80, Infinity], color: '#01238a' },
            ];
            let sd = parseInt(this.weather.SD);
            this.sdColor = humidityRanges.find(h => sd >= h.range[0] && sd < h.range[1]).color;

            // PM2.5质量颜色
            const aqiRanges = [
              { range: [-Infinity, 35], color: '#89f51d' },
              { range: [35, 75], color: '#f5c20d' },
              { range: [75, 115], color: '#f6990b' },
              { range: [115, 150], color: '#ec1c1c' },
              { range: [150, 250], color: '#9514e5' },
              { range: [250, Infinity], color: '#fd0303' },
            ];
            this.pmColor = aqiRanges.find(aqiRange => this.weather.aqi >= aqiRange.range[0] && this.weather.aqi < aqiRange.range[1]).color;

          })
    },
    fetchLayoutConfig() {
      // axios.get('/api/layout-config').then(response => {
        this.layout = '3X2';
        this.components = ['nightingale',
          'mixLineBar',
          'monthProduct',
          'quarterProduct',
          'yearProduct'];
      // });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/indexData.scss';
.layout-3x3 { display: grid; grid-template-columns: repeat(3, 1fr); }
.layout-3x2 { display: grid; grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(2, 1fr); }
.component-item { padding: 10px; }
.bg-kg {
  //background-color: rgba(103, 145, 61, 0.32);

}
.snowflake {
  --size: 5vw;
  width: var(--size);
  height: var(--size);
  //background: url("../assets/xuehua.png") no-repeat;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  background-size: 100% 100%;
  position: fixed;
  z-index: -1;
  top: -5vh;
}

@keyframes snowfall {
  100% {
    transform: translate3d(var(--end), 100vh, 0);
  }
}

@for $i from 0 through 500 {
  .snowflake:nth-child(#{$i}) {
    //每个雪花的大小
    --size: #{random(6) * 0.08}vw;
    //雪花移动目标点 -70后是负数 这样雪花会向左下方飘落
    --end: #{random(20) - 70}vw;
    //雪花初始位置
    left: #{random(180)}vw;
    //雪花从顶到底移动的动画 动画时间可以调整雪花速度
    animation: snowfall #{10 + random(16)}s linear infinite;
    animation-delay: -#{random(10)}s;
  }
}
</style>
